import(/* webpackMode: "eager" */ "/home/runner/work/ai-realtime-game/ai-realtime-game/apps/client/app/(bg)/page.tsx");
